import {Injectable} from '@angular/core';
import {HttpService} from '../http/http.service';
import {catchError, map, Observable} from 'rxjs';
import {iResponseList} from '../../models/response/response.model';
import {DocumentTypeModel} from '../../models/document-types/document-type';
export interface ValueModel {
    id: string;
    value: string;
}
@Injectable({
    providedIn: 'root'
})
export class ValueService extends HttpService {

    getStates(): Observable<any> {
        return this.get(`values/states`).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    getPrescriptionFormats(): Observable<any> {
        return this.get(`values/prescription-formats`).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    getDocumentTypes(): Observable<iResponseList<DocumentTypeModel>> {
        return this.get(`values/document-types`).pipe(
            map((response: iResponseList<DocumentTypeModel>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    // drug drug-dosages

    getDosages(): Observable<iResponseList<ValueModel>> {
        return this.get(`values/drug-dosages`).pipe(
            map((response: iResponseList<ValueModel>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    postDosages(value: ValueModel): Observable<any> {
        return this.post(`values/drug-dosages`, value).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    putDosages(value: ValueModel): Observable<any> {
        return this.put(`values/drug-dosages/${value.id}`, value).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    deleteDosages(id: string): Observable<any> {
        return this.delete(`values/drug-dosages/${id}`).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    // drug drug-processings

    getProcessing(): Observable<iResponseList<ValueModel>> {
        return this.get(`values/drug-processings`).pipe(
            map((response: iResponseList<ValueModel>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    postProcessing(value: ValueModel): Observable<any> {
        return this.post(`values/drug-processings`, value).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    putProcessing(value: ValueModel): Observable<any> {
        return this.put(`values/drug-processings/${value.id}`, value).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }

    deleteProcessing(id: string): Observable<any> {
        return this.delete(`values/drug-processings/${id}`).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }
}
